import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { MessageErreur } from '@components/message-erreur/models';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-message-erreur',
  templateUrl: './message-erreur.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, TitleComponent],
})
export class MessageErreurComponent extends AbstractDynamicComponent<MessageErreur> {}
